import React, { useContext } from "react";
import { MdWarningAmber  } from "react-icons/md";
import { httpsCallable } from "firebase/functions";
import { FirebaseContext } from '../services/Firebase';
import toast from 'react-hot-toast';
import { useNavigate } from "react-router-dom";


const TrainingDeletionSection = ({ id }: any) => {
  const navigate = useNavigate()
  const { functions } = useContext(FirebaseContext) || {}
  
  const onDelete = (e: any) => {
    e.preventDefault()
    if(window.confirm("En supprimant la formation, vous supprimerez tous les éléments associés (scénarios, etc). Êtes-vous sûr de vouloir supprimer ?")) {
      if(!functions) return
      const deleteSequences = httpsCallable(functions, 'training-call-deleteTraining');
      toast.promise(deleteSequences({ trainId: id }), {
        loading: 'Suppression...',
        success: "Supprimé !",
        error: "Une erreur est survenue !"
      })
      .then(() => navigate(-1))
    }
  }

  return (
    <div className="p-10 flex flex-col justify-center items-center">
            <MdWarningAmber  className="text-red-500 text-4xl sm:text-5xl"/>
            <h2 className="text-2xl font-extrabold text-black sm:text-3xl text-center">
                <span className="block">
                    Êtes-vous sûr de vouloir supprimer la formation ?
                </span>
            </h2>
            <p className="text-xl mt-4 text-gray-400 text-center">
              En supprimant cette formation, vous allez aussi supprimer l'ensemble des éléments associés (modules, scénarios, etc.). Cette action est irrémédiable.
            </p>
            <div className="lg:mt-0 lg:flex-shrink-0">
                <div className="mt-12 inline-flex rounded-md shadow">
                    <button onClick={onDelete} type="button" className="p-2  bg-red-600 hover:bg-red-700 focus:ring-red-500 focus:ring-offset-red-200 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg ">
                        Supprimer
                    </button>
                </div>
            </div>
    </div>
  );
}

export default TrainingDeletionSection
